export default __webpack_public_path__ + "static/media/3.07827f97.jpg";